module.exports = __webpack_public_path__ + "static/media/bell.2514cc18.svg";